import * as API from '@/generated/api/api';
import env from '@env';

namespace BASEAPI {
    export type User = API.User;
    export type FormData = API.FormData;
    export type Product = API.Product;
    export type ProductPrizeGroup = API.ProductPrizeGroup;
    export type Prize = API.Prize;
    export type UserProductShip = API.UserProductShip;
    export type OrderHistory = API.OrderHistory;
    export type UserPrize = API.UserPrize;

    export function user(): API.User {
        return {
            email: "",
            name: "",
            zip: "",
            address: "",
            address2: "",
            birthday: "",
            gender: <any>"",
            tel: "",
            code: "",
        };
    }

    export function productPrizeGroup(): API.ProductPrizeGroup {
        return {
            category: API.ProductPrizeGroupCategoryEnum.Normal,
            ratio: 0,
            rank: 0
        };
    }


    export const LoginController = API.LoginControllerApiFactory({ baseOptions: env.API_CLNFIG }, env.API_ORIGIN);
    export const UserController = API.UserControllerApiFactory({ baseOptions: env.API_CLNFIG }, env.API_ORIGIN);
    export const MailController = API.MailControllerApiFactory({ baseOptions: env.API_CLNFIG }, env.API_ORIGIN);
    export const CreditController = API.CreditControllerApiFactory({ baseOptions: env.API_CLNFIG }, env.API_ORIGIN);
    export const RedirectController = API.RedirectControllerApiFactory({ baseOptions: env.API_CLNFIG }, env.API_ORIGIN);
    export const ProductController = API.ProductControllerApiFactory({ baseOptions: env.API_CLNFIG }, env.API_ORIGIN);
    export const UserProductShipController = API.UserProductShipControllerApiFactory({ baseOptions: env.API_CLNFIG }, env.API_ORIGIN);
    export const OrderHistoryController = API.OrderHistoryControllerApiFactory({ baseOptions: env.API_CLNFIG }, env.API_ORIGIN);
    export const OrderHistoryPrizeController = API.OrderHistoryPrizeControllerApiFactory({ baseOptions: env.API_CLNFIG }, env.API_ORIGIN);
}
export default BASEAPI;
